module.exports = __webpack_public_path__ + "static/jeanine-004-77076426a7c6d60c8d58466a056d5b2a.jpg";